import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
const accessToken = localStorage.getItem('accessToken');
if (accessToken) {
  axios.defaults.headers.common = {'Authorization': `Bearer ${accessToken}`};
}

export default axios;